import { Link } from "react-router-dom";
import { LOGO_URL, SITE_NAME } from "@/constants/site";

const CATEGORY_LINKS = [
  { to: "/category/movie", label: "电影大全" },
  { to: "/category/tv", label: "电视剧大全" },
  { to: "/category/movie?genre=科幻", label: "科幻片" },
  { to: "/category/movie?genre=悬疑", label: "悬疑片" },
  { to: "/category/tv?genre=古装", label: "古装剧" },
  { to: "/category/tv?genre=爱情", label: "爱情剧" },
];

const ABOUT_LINKS = [
  { to: "/about", label: "平台介绍" },
  { to: "/about", label: "联系方式" },
  { to: "/about", label: "常见问题" },
  { to: "/about", label: "服务声明" },
];

const FRIEND_LINKS = ["光影资料库", "观影指南", "影评社区", "排片日历"];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-foreground-950">
                <img src={LOGO_URL} alt="熊猫影院 Logo" className="h-9 w-9 object-cover" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {SITE_NAME}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              熊猫影院是为广大影视爱好者打造的在线影视内容平台，提供电影与电视剧的查询、筛选与观看入口，致力于让每一次观影都轻松愉快。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">
              <span className="cursor-default">影视分类</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {CATEGORY_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">
              <span className="cursor-default">关于平台</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {ABOUT_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">
              <span className="cursor-default">友情链接</span>
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {FRIEND_LINKS.map((name) => (
                <span
                  key={name}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
                >
                  {name}
                </span>
              ))}
            </div>
            <p className="mt-5 text-xs leading-relaxed text-foreground-500">
              本站影视信息均为虚构演示内容，仅供产品展示使用。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 熊猫影院 Panda Cinema · 保留所有权利</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span className="cursor-pointer transition-colors hover:text-primary-600">隐私政策</span>
            <span className="cursor-pointer transition-colors hover:text-primary-600">用户协议</span>
            <span className="cursor-pointer transition-colors hover:text-primary-600">版权声明</span>
          </p>
        </div>
      </div>
    </footer>
  );
}